import React from 'react';
import { DefaultLayout, defaultLayoutChooser } from '../utils/layout';
import { LayoutHandler } from '@food/ui';
import { Route } from 'react-router';
import { parse, ParsedUrlQuery } from 'querystring';
import { TUserExtendedData, UserExtendedData } from './UserExtendedData';
import { Spinner } from './Spinner';

export interface ILocation {
	pathname: string;
	search: ParsedUrlQuery;
}

export interface IPageData {
	layout: DefaultLayout;
	user: TUserExtendedData | null;
	history: any;
	location: ILocation;
	magazineId?: string;
}

export interface IDefaultPageDataProps {
	children: (args: IPageData) => JSX.Element;
}

export const DefaultPageData: React.FC<IDefaultPageDataProps> = ({ children }) => (
	<UserExtendedData>
		{(loading, extendedData) => {
			if (loading) {
				return <Spinner />;
			} else {
				return (
					<Route>
						{({ location, history }) => (
							<LayoutHandler layouts={{ layout: defaultLayoutChooser }}>
								{({ layout }) =>
									children({
										layout: layout as DefaultLayout,
										user: extendedData,
										history,
										location: {
											pathname: location.pathname,
											search: parse(location.search.slice(1)),
										},
									})
								}
							</LayoutHandler>
						)}
					</Route>
				);
			}
		}}
	</UserExtendedData>
);
